import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MatchForm } from "@/components/MatchForm";
import { HomeReviews } from "@/components/HomeReviews";
import { Marquee } from "@/components/Marquee";
import { HowItWorks } from "@/components/HowItWorks";
import { HomeRequests } from "@/components/HomeRequests";
import { AgencySection } from "@/components/AgencySection";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { SupportChat } from "@/components/SupportChat";
import Admin from "@/pages/Admin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Richieste from "@/pages/Richieste";
import Recensione from "@/pages/Recensione";
import Riscontro from "@/pages/Riscontro";
import Match from "@/pages/Match";
import CookiePolicy from "@/pages/CookiePolicy";

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <MatchForm />
      <HomeReviews />
      <Marquee />
      <HowItWorks />
      <HomeRequests />
      <AgencySection />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/richieste" element={<Richieste />} />
          <Route path="/recensione" element={<Recensione />} />
          <Route path="/riscontro" element={<Riscontro />} />
          <Route path="/chat" element={<Match />} />
          <Route path="/match" element={<Match />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/vetrina" element={<Navigate to="/richieste" replace />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
      <SupportChat />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
